import { Avatar, Button, Text, TextField } from '@cinesend/ui-kit'
import { Trash, UploadSimple } from '@phosphor-icons/react'
import { useRef, useState } from 'react'
import axios from 'axios'
import { useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from '../../hooks/use_snackbar'
import SettingsCard from '../../components/settings_card'

export default function Profile({ user, updateUser }) {
  const [name, setName] = useState(user.name)
  const [saving, setSaving] = useState(false)
  const fileInput = useRef(null)
  const queryClient = useQueryClient()
  const { addMessage } = useSnackbar()
  const avatarUrl = user.avatar_url || undefined

  const changeAvatar = async (request) => {
    setSaving(true)
    try {
      await request()
      await queryClient.invalidateQueries(['/user'])
    } catch (err) {
      addMessage(err.response?.data?.message ?? 'Unable to update profile image', 'error')
    } finally {
      setSaving(false)
    }
  }

  const uploadAvatar = (e) => {
    const file = e.target.files[0]
    e.target.value = ''
    if (file) {
      changeAvatar(() => axios.put(`users/${user.id}/avatar`, file, { headers: { 'Content-Type': file.type } }))
    }
  }

  return (
    <SettingsCard title='Personal'>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-1.5'>
          <Text variant='sm-medium'>Profile image</Text>
          <Text variant='sm' tone='secondary'>
            JPEG or PNG, up to 5MB.
          </Text>
        </div>
        <div className='flex flex-wrap items-center gap-3'>
          <Avatar name={name || user.name || '?'} imageSrc={avatarUrl} size='3xl' />
          <input ref={fileInput} type='file' accept='.jpg,.jpeg,.png' className='hidden' onChange={uploadAvatar} />
          <Button
            type='button'
            variant='secondary'
            disabled={saving}
            onClick={() => fileInput.current.click()}
            leadingIcon={<UploadSimple size={20} weight='regular' aria-hidden='true' />}
          >
            {avatarUrl ? 'Replace' : 'Upload'}
          </Button>
          {avatarUrl ? (
            <Button
              type='button'
              variant='ghost'
              disabled={saving}
              onClick={() => changeAvatar(() => axios.delete(`users/${user.id}/avatar`))}
              leadingIcon={<Trash size={20} weight='regular' aria-hidden='true' />}
            >
              Remove
            </Button>
          ) : null}
        </div>
      </div>
      <div className='h-px w-full bg-[var(--cs-color-border-default)]' role='separator' />
      <TextField label='Full name' value={name} onChange={(e) => setName(e.target.value)} />
      <TextField label='Email' value={user.email ?? ''} disabled />
      <div className='flex justify-end'>
        <Button disabled={name === user.name} onClick={() => updateUser({ name })}>
          Save
        </Button>
      </div>
    </SettingsCard>
  )
}
